module.exports = __webpack_public_path__ + "img/28.d078c11c.png";